import { render, staticRenderFns } from "./QuickDataTable.vue?vue&type=template&id=53eab6a5&"
import script from "./QuickDataTable.vue?vue&type=script&lang=js&"
export * from "./QuickDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports